import { useEffect } from "react";
import { useDispatch } from "react-redux";
import { setLayoutDashboardTitle } from "../../../store/ui-slice";
import CustomerReportMain from "./component/CustomerReportMain";

const title = "Customer Spending";

const CustomerReportMainPage = () => {
  const dispatch = useDispatch();

  useEffect(() => {
    dispatch(setLayoutDashboardTitle({ title }));
  }, []);

  return <CustomerReportMain />;
};

export default CustomerReportMainPage;
